"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.getIconColor = void 0;

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

function getIconColor(_a, state) {
  var icon = _a.icon;
  var color = icon && icon.attrs.viewportFill;

  if (!color) {
    return;
  }

  return state ? state(color) : color;
}

exports.getIconColor = getIconColor;

exports.styles = function (_a) {
  var fontSize = _a.fontSize,
      fontFamily = _a.fontFamily,
      sizeBorderRadius = _a.sizeBorderRadius,
      stateHover = _a.stateHover,
      stateActive = _a.stateActive,
      colorBg = _a.colorBg,
      colorText = _a.colorText,
      colorBorder = _a.colorBorder,
      colorBgSecondary = _a.colorBgSecondary,
      colorTextContrast = _a.colorTextContrast,
      colorTextSecondary = _a.colorTextSecondary,
      colorIconContrast = _a.colorIconContrast,
      colorPrimary = _a.colorPrimary,
      colorSecondary = _a.colorSecondary,
      colorError = _a.colorError,
      colorWarning = _a.colorRating,
      colorIconSecondary = _a.colorIconSecondary,
      toneValueBase = _a.toneValueBase,
      paddingControlButton = _a.paddingControlButton,
      sizeControlHeight = _a.sizeControlHeight,
      sizeControlButtonSmallHeight = _a.sizeControlButtonSmallHeight,
      sizeControlButtonLargeHeight = _a.sizeControlButtonLargeHeight,
      sizeControlButtonLargeWidth = _a.sizeControlButtonLargeWidth,
      sizeControlButtonIconWidth = _a.sizeControlButtonIconWidth,
      x2 = _a.x2,
      x4 = _a.x4,
      x12 = _a.x12;
  return __assign(__assign({
    base: {
      fontFamily: fontFamily,
      fontSize: fontSize,
      backgroundColor: colorBgSecondary.normal,
      borderRadius: sizeBorderRadius,
      border: 'none',
      color: colorText.normal,
      lineHeight: 1,
      height: sizeControlHeight,
      '& $innerText': {
        lineHeight: sizeControlHeight + "px"
      },
      padding: "0 " + paddingControlButton + "px",
      textShadow: 'none',
      userSelect: 'none',
      outline: 'none',
      cursor: 'pointer',
      position: 'relative',
      boxSizing: 'border-box',
      display: 'inline-block',
      '&:hover, &$hover': {
        backgroundColor: colorBgSecondary.hover
      },
      '&:active, &$active': {
        backgroundColor: colorBgSecondary.active
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: colorBgSecondary.normal
        },
        '&:active, &$active': {
          backgroundColor: colorBgSecondary.normal
        }
      },
      '& $iconWithText svg': {
        fill: colorText.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorText.normal
      }
    },
    inner: {
      display: 'inline-block'
    },
    innerIcon: {
      fontSize: 0,
      verticalAlign: 'middle'
    },
    innerText: {
      verticalAlign: 'middle'
    },
    fluid: {
      width: '100%'
    },
    large: {
      height: sizeControlButtonLargeHeight,
      '& $innerText': {
        lineHeight: sizeControlButtonLargeHeight + "px"
      }
    },
    small: {
      height: sizeControlButtonSmallHeight,
      '& $innerText': {
        lineHeight: sizeControlButtonSmallHeight + "px"
      }
    },
    flat: {
      backgroundColor: 'transparent',
      color: colorPrimary.normal,
      boxShadow: 'none',
      border: 'none',
      '&:hover, &$hover': {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      },
      '&:active, &$active': {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
      },
      '& $iconWithText svg': {
        fill: colorPrimary.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorPrimary.normal
      }
    },
    contrast: {
      backgroundColor: colorBg.normal,
      color: colorText.normal,
      '&:hover, &$hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      },
      '&:active, &$active': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
      },
      '& $iconWithText svg': {
        fill: colorPrimary.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorPrimary.normal
      }
    },
    progress: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-align': 'center',
        '-ms-flex-pack': 'center',
        '-ms-flex-direction': 'row'
      }, {
        display: '-webkit-box',
        '-webkit-box-align': 'center',
        '-webkit-box-pack': 'center',
        '-webkit-box-orient': 'horizontal',
        '-webkit-box-direction': 'normal'
      }, {
        display: '-webkit-flex',
        '-webkit-align-items': 'center',
        '-webkit-justify-content': 'center',
        '-webkit-flex-direction': 'row'
      }]
    },
    progressText: {
      verticalAlign: 'middle',
      paddingRight: x2,
      height: x4
    },
    primary: {
      backgroundColor: colorPrimary.normal,
      color: colorTextContrast.normal,
      '&:hover, &$hover': {
        backgroundColor: colorPrimary.hover
      },
      '&:active, &$active': {
        backgroundColor: colorPrimary.active
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: colorPrimary.normal
        },
        '&:active, &$active': {
          backgroundColor: colorPrimary.normal
        }
      },
      '& $iconWithText svg': {
        fill: colorIconContrast.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorIconContrast.normal
      },
      '&$variantFlat': {
        color: colorPrimary.normal,
        backgroundColor: 'transparent'
      }
    },
    warning: {
      backgroundColor: colorWarning.normal,
      color: colorBg.normal,
      '&:hover, &$hover': {
        backgroundColor: colorWarning.hover
      },
      '&:active, &$active': {
        backgroundColor: colorWarning.active
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: colorWarning.normal
        },
        '&:active, &$active': {
          backgroundColor: colorWarning.normal
        }
      },
      '& $iconWithText svg': {
        fill: colorBg.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorBg.normal
      },
      '&$variantFlat': {
        color: colorWarning.normal,
        backgroundColor: 'transparent'
      }
    },
    danger: {
      backgroundColor: colorError.normal,
      color: colorBg.normal,
      '&:hover, &$hover': {
        backgroundColor: colorError.hover
      },
      '&:active, &$active': {
        backgroundColor: colorError.active
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: colorError.normal
        },
        '&:active, &$active': {
          backgroundColor: colorError.normal
        }
      },
      '& $iconWithText svg': {
        fill: colorBg.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorBg.normal
      },
      '&$variantFlat': {
        color: colorError.normal,
        backgroundColor: 'transparent'
      }
    },
    secondary: {
      backgroundColor: colorSecondary.normal,
      color: colorTextContrast.normal,
      '&:hover, &$hover': {
        backgroundColor: colorSecondary.hover
      },
      '&:active, &$active': {
        backgroundColor: colorSecondary.active
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: colorSecondary.normal
        },
        '&:active, &$active': {
          backgroundColor: colorSecondary.normal
        }
      },
      '& $iconWithText svg': {
        fill: colorBg.normal
      },
      '& $iconWithTextBefore svg': {
        fill: colorBg.normal
      },
      '&$variantFlat': {
        color: colorTextSecondary.normal,
        backgroundColor: 'transparent',
        '& $iconWithText svg': {
          fill: colorIconSecondary.normal
        },
        '& $iconWithTextBefore svg': {
          fill: colorIconSecondary.normal
        }
      }
    },
    bgColorInheritFromIcon: {
      color: colorTextContrast.normal,
      backgroundColor: function backgroundColor(props) {
        return getIconColor(props);
      },
      '&:hover:not($variantFlat), &$hover:not($variantFlat)': {
        backgroundColor: function backgroundColor(props) {
          return getIconColor(props, stateHover);
        }
      },
      '&:active:not($variantFlat), &$active:not($variantFlat)': {
        backgroundColor: function backgroundColor(props) {
          return getIconColor(props, stateActive);
        }
      },
      '&$disabled:not($variantFlat), &$progressWrapper:not($variantFlat)': {
        '&:hover, &$hover': {
          backgroundColor: function backgroundColor(props) {
            return getIconColor(props);
          }
        },
        '&:active, &$active': {
          backgroundColor: function backgroundColor(props) {
            return getIconColor(props);
          }
        }
      },
      '& $iconWithText svg': {
        fill: 'currentColor'
      },
      '& $iconWithTextBefore svg': {
        fill: 'currentColor'
      },
      '&$variantFlat': {
        color: function color(props) {
          return getIconColor(props);
        },
        backgroundColor: 'transparent'
      }
    },
    variantFlat: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: 'none',
      '&:hover, &$hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      },
      '&:active, &$active': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
      },
      '& $iconWithText svg': {
        fill: 'currentColor'
      },
      '& $iconWithTextBefore svg': {
        fill: 'currentColor'
      }
    },
    round: {},
    icon: {
      '&$round': {
        borderRadius: '50%'
      },
      '&$large': {
        width: sizeControlButtonLargeWidth
      },
      '&$small': {
        // Токен с шириной сейчас занят под минимальную ширину кнопки с текстом, поэтому используем высоту
        width: sizeControlButtonSmallHeight
      },
      width: sizeControlButtonIconWidth,
      padding: '0 7px 0',
      '& svg': {
        verticalAlign: 'middle'
      }
    },
    iconWithText: {
      paddingRight: 10
    },
    iconWithTextBefore: {
      paddingLeft: 10
    },
    disabled: {
      opacity: toneValueBase,
      cursor: 'default',
      '&:focus, &$focus': {
        borderColor: colorBorder.normal
      },
      '&$progressWrapper': {
        opacity: 1
      }
    },
    progressWrapper: {
      cursor: 'default',
      '&:focus, &$focus': {
        borderColor: colorBorder.normal
      }
    }
  }, mobileStylesHelper_1.default({
    height: 48,
    '&$round': {
      padding: 0
    },
    '&$icon$small': {
      height: sizeControlButtonSmallHeight
    },
    '&$icon&$large': {
      height: sizeControlButtonLargeHeight
    },
    '& $innerText': {
      lineHeight: x12 + "px"
    },
    padding: '0 20px',
    '&:not($round)': {
      width: '100%'
    },
    fontWeight: 'bold'
  })), {
    focus: {},
    hover: {},
    active: {}
  });
};